TrelloModel = require 'models/internal/trello-model'

module.exports = class SavedSearch extends TrelloModel
  typeName: 'SavedSearch'



// WEBPACK FOOTER //
// ./app/scripts/models/saved-search.coffee